export default __webpack_public_path__ + "static/media/revicon5.5f878ee5.svg";